<template>
    <div>
        <app-sub-title text="Ingresos de vehículos de carga" />
        <b-button
            v-if="isVigilant"
            variant="primary"
            @click="startSave"
            class="btn-block-xs-only"
            ><i class="fa fa-plus"></i> Crear ingreso vehículo de
            carga</b-button
        >
        <app-cargo-vehicle-entries-filters
            @filter="onFilter"
            :authors="authors"
            :haveAClient="haveAClient"
        />
        <app-cargo-vehicle-entries-list
            :data="data"
            @change-page="changePage"
            @register-vehicle-departure="startRegisterDeparture"
            @remove-cargo-vehicle-entry="startRemove"
            @upload-photos="startUploadPhotos"
            @sort="onSort"
            @see-card="seeCard"
            :isVigilant="isVigilant"
        />

        <!-- inicio de pop ups -->
        <app-pop-up
            title="Ingreso vehículo de carga"
            size="large"
            id="cargo-vehicle-entry-form"
            :onClose="cleanForm"
        >
            <div class="body" slot="body">
                <app-cargo-vehicle-entry-form
                    v-if="isVigilant"
                    :my-entry="selectedEntry"
                    :onSave="onSave"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('cargo-vehicle-entry-form.save')"
                >
                    Guardar ingreso
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            size="large"
            :title="
                'Salida vehículo de carga con placas ' + selectedEntry.plate
            "
            id="cargo-vehicle-departure-form"
            :onClose="cleanDepartureForm"
        >
            <div class="body" slot="body">
                <app-cargo-vehicle-departure-form
                    v-if="isVigilant"
                    :my-entry="selectedEntry"
                    :onSave="onSaveDeparture"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('cargo-vehicle-departure-form.save')"
                >
                    Guardar salida
                </button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="cargo-vehicle-entry-remove">
            <div slot="body">
                <h2>¿Esta seguro que desea eliminar este ingreso?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="deleteEntry(selectedEntry)"
                >
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar
                    Eliminación
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Agregar fotos"
            id="upload-cargo-vehicle-entry-photos"
            :onClose="cleanFormFiles"
        >
            <div slot="body">
                <b-card tag="article" style="max-width: 100%;" class="mb-2">
                    <div class="card-text">
                        <app-upload-or-take-photo
                            id="upload-cargo-vehicle-entry-photos"
                            title="Fotos de vehículo de carga"
                            v-model="files"
                        />
                        <div v-if="files">
                            <button
                                class="btn btn-sm btn-danger pull-right"
                                @click="cancelFilesSelected"
                            >
                                <i class="fa fa-trash-o" aria-hidden="true"></i>
                                Cancelar archivos seleccionados
                            </button>
                        </div>
                    </div>
                </b-card>
            </div>
            <div class="buttons" slot="buttons">
                <b-button
                    variant="primary"
                    class="btn-block-xs-only"
                    :disabled="!files ? !files : inProgress"
                    @click="savePhotos(selectedEntry)"
                    ><i class="fa fa-floppy-o"></i> Guardar fotos</b-button
                >
            </div>
        </app-pop-up>

        <app-pop-up
            size="large"
            title="Ingreso de vehículo de carga"
            id="cargo-vehicle-entry-card"
        >
            <div slot="body">
                <app-card-vehicle-entry
                    v-if="selectedEntry"
                    :vehicle-entry="selectedEntry"
                />
            </div>
        </app-pop-up>
        <!-- fin de pop ups -->
    </div>
</template>

<script>
import CargoVehicleEntriesList from "./CargoVehicleEntriesList/CargoVehicleEntriesList.vue";
import CargoVehicleEntriesFilters from "./CargoVehicleEntriesFilters/CargoVehicleEntriesFilters.vue";
import CargoVehicleEntryForm from "./CargoVehicleEntryForm/CargoVehicleEntryForm.vue";
import CargoVehicleDepartureForm from "./CargoVehicleDepartureForm/CargoVehicleDepartureForm.vue";
import CardVehicleEntry from "../../Departures/CargoVehicle/CardCargoVehicleEntry/CardCargoVehicleEntry";
import cargoVehicleEntriesRepository from "../../../../../repositories/cargoVehicleEntries.repository";
import UploadOrTakePhoto from "../../../../UI/Controls/Photos/UploadOrTakePhoto.vue";
export default {
    components: {
        appCargoVehicleEntriesList: CargoVehicleEntriesList,
        appCargoVehicleEntriesFilters: CargoVehicleEntriesFilters,
        appCargoVehicleEntryForm: CargoVehicleEntryForm,
        appCargoVehicleDepartureForm: CargoVehicleDepartureForm,
        appUploadOrTakePhoto: UploadOrTakePhoto,
        appCardVehicleEntry: CardVehicleEntry
    },
    data() {
        return {
            data: {},
            authors: [],
            selectedEntry: "",
            sort: {
                sortBy: "created_at",
                sortDir: "desc"
            },
            theFilters: {},
            page: 1,
            files: ""
        };
    },
    computed: {
        isVigilant() {
            return this.user.profile.slug === "vigilante";
        },
        haveAClient() {
            return !!this.client;
        }
    },
    methods: {
        loadCargoVehicleEntries() {
            const cver = { ...cargoVehicleEntriesRepository };
            if (this.haveAClient) {
                const filters = {
                    ...this.theFilters,
                    sortBy: this.sort.sortBy,
                    sortDir: this.sort.sortDir,
                    client: this.client.id
                };
                this.isVigilant && (filters.open = 1);
                cver.loadCargoVehicleEntries(filters, this.page)
                    .then(({ data }) => {
                        this.data = data;
                    })
                    .catch(error => {
                        toastr.error(
                            "Error al cargar los ingresos de vehículos de carga"
                        );
                    });
            } else {
                const filters = {
                    ...this.theFilters,
                    sortBy: this.sort.sortBy,
                    sortDir: this.sort.sortDir
                };
                cver.loadCargoVehicleEntries(filters, this.page)
                    .then(({ data }) => {
                        this.data = data;
                    })
                    .catch(error => {
                        toastr.error(
                            "Error al cargar los ingresos de vehículos de carga"
                        );
                    });
            }
        },
        changePage(page) {
            this.page = page;
            this.loadCargoVehicleEntries();
        },
        loadAuthorsCargoVehicleEntries() {
            const cver = { ...cargoVehicleEntriesRepository };
            cver.loadCargoVehicleEntriesAuthors()
                .then(({ data }) => (this.authors = data))
                .catch(error =>
                    toastr.error("Ocurrió un error al cargar los autores")
                );
        },
        seeCard(cargoVehicleEntry) {
            this.selectedEntry = cargoVehicleEntry;
            this.$bus.$emit("cargo-vehicle-entry-card.open");
        },
        startSave() {
            this.selectedEntry = "";

            this.$bus.$emit("cargo-vehicle-entry-form.open");
        },
        startRegisterDeparture(cargoVehicleEntry) {
            this.selectedEntry = Object.assign({}, cargoVehicleEntry);
            this.$bus.$emit("cargo-vehicle-departure-form.open");
        },
        startRemove(cargoVehicleEntry) {
            this.selectedEntry = cargoVehicleEntry;
            this.$bus.$emit("cargo-vehicle-entry-remove.open");
        },
        startUploadPhotos(cargoVehicleEntry) {
            this.selectedEntry = cargoVehicleEntry;
            this.$bus.$emit("upload-cargo-vehicle-entry-photos.open");
        },
        cleanForm() {
            this.$bus.$emit("cargo-vehicle-entry-form.clean");
        },
        cleanFormFiles() {
            this.$bus.$emit("upload-cargo-vehicle-entry-photos.clean");
            this.files = "";
        },
        cleanDepartureForm() {
            this.$bus.$emit("cargo-vehicle-departure-form.clean");
        },
        onSave() {
            this.$bus.$emit("cargo-vehicle-entry-form.close");
            this.loadCargoVehicleEntries();
        },
        onSaveDeparture() {
            this.$bus.$emit("cargo-vehicle-departure-form.close");
            this.loadCargoVehicleEntries();
        },
        deleteEntry(cargoVehicleEntry) {
            const cver = { ...cargoVehicleEntriesRepository };
            cver.deleteCargoVehicleEntry(cargoVehicleEntry.id)
                .then(({ data }) => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadCargoVehicleEntries();
                        this.$bus.$emit("cargo-vehicle-entry-remove.close");
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error(
                        "No se pudo borrar el ingreso de vehículo de carga"
                    );
                });
        },
        savePhotos() {
            const formData = new FormData();

            formData.append("entryId", this.selectedEntry.id);

            if (this.files.photos) {
                this.files.photos.map(item =>
                    formData.append("photos[]", item)
                );
            }
            if (this.files.files) {
                this.files.files.map((item, index) =>
                    formData.append("file" + index, item)
                );
            }

            const cver = { ...cargoVehicleEntriesRepository };
            cver.saveCargoVehicleEntryPhotos(formData)
                .then(({ data }) => {
                    if (data.status) {
                        this.loadCargoVehicleEntries();
                        toastr.success(data.msg);
                        this.$bus.$emit(
                            "upload-cargo-vehicle-entry-photos.close"
                        );
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error(
                        "Error al guardar las fotos del vehículo de carga"
                    );
                });
        },
        cancelFilesSelected() {
            this.$bus.$emit("upload-cargo-vehicle-entry-photos.clean");
            this.files = "";
            toastr.success("Archivos cancelados");
        },
        onFilter(filters) {
            this.theFilters = filters;
            this.loadCargoVehicleEntries();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadCargoVehicleEntries();
        },
        initialize() {
            this.loadCargoVehicleEntries();
            this.loadAuthorsCargoVehicleEntries();
        }
    },
    created() {
        this.initialize();
    }
};
</script>
